export const toggleTheme = () => {
    return {
        type: 'toggle'
    }
}